export const logEvent = (category = '', action = '', label = '') => {
  if (category && action) {
    console.log(category, action, label);
    (window as any).dataLayer.push({
      'event': 'gaEvent',
      'eventCategory': category,
      'eventAction': action,
      'eventLabel': label
    });
  }
}

export function logHomeEvent(category = '', action = '', label = '') {
  try {
    if (category && action) {
      window.ga('send', 'event', category, action, label)
    }
  } catch (e) {
    // console.error(e)
  }
}

export function pageview(url) {
  try {
    window.ga('send', 'pageview', url)
  } catch (e) {
    console.error(e)
  }
}